export const locale = {
  lang: 'fr-CA',
  data: {
    COMBO_PANEL: {
      TITLE: 'Modifier le combo',
      TITLE_CREATE: 'Créer un combo',
      TITLE_CREATE_DYNAMIC: 'Créer un combo dynamique',
      LEFT_LIST_LABEL:
        'Glisser et déposer ou utiliser le bouton + pour ajouter des produits',
      RIGHT_LIST_LABEL: 'Réordonner, ajuster ou enlever un produit du combo',
      CREATE_PRODUCT: 'Créer un produit',
      SEARCH: 'recherche par nom interne, nom externe ou code de produit',
      SEARCH_PRODUCT: 'Effectuez une recherche de votre produit.',
      CATEGORY_FILTER: 'Catégorie de produit',
      TAGS_FILTER: 'Tags',
      NO_SEARCH_RESULTS: 'Aucun résultat pour votre recherche.',
      NO_SEARCH_RESULTS_TRY_AGAIN: 'Veuillez essayer autre chose.',
      MULTIPLY_CHILD_QTY: 'Multiplier quantité enfants combo',
      COMBO_SUFFIX: 'Combo',
      COMBO_DYNAMIC_SUFFIX: 'Combo dynamique',
      REMOVE_ITEM: 'Retirer du combo',
    },
  },
};
